import React from "react";
import { useTranslation } from "react-i18next";
import GridContainer from "components/Grid/GridContainer";
import style from "./ActivitiesInfoStyle";
import { makeStyles } from "@material-ui/core/styles";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import Info from "components/Typography/Info.js";
import defaultProfileImage from "assets/img/convention/collageTest.jpg";
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import i18next from "i18next";
import { useMediaQuery } from "@material-ui/core";
import ActivityCardMobile from "components/ActivityInfoMobile/ActivityInfoMobile";

const useStyles = makeStyles(style, styles);

export default function ActivitiesInfo({ activity }) {
  const { t } = useTranslation(["common"]);
  const getCurrentLng = () =>
    i18next.language || window.localStorage.i18nextLng || "en";
  const selectedLanguage = getCurrentLng();
  const { description, img, title } = activity;
  const isMobile = useMediaQuery("(max-width:681px)");

  const classes = useStyles();

  return (
    <>
      {isMobile ? (
        <ActivityCardMobile activity={activity} />
      ) : (
        <GridContainer className={classes.activityContainer}>
          <Card blog className={classes.activityCard}>
            <CardHeader image>
              <img
                src={img || defaultProfileImage}
                alt={title}
                className={classes.img}
              />
            </CardHeader>
            <CardBody style={{ flexGrow: 1 }}>
              <Info>
                <h5 style={{ color: "black" }} className={classes.title}>
                  {title[selectedLanguage]}
                </h5>
              </Info>
              <div style={{ color: "black" }} className={classes.description}>
                <p>{description[selectedLanguage]}</p>
              </div>
            </CardBody>
          </Card>
        </GridContainer>
      )}
    </>
  );
}
